import { SvgIcon, type SvgIconProps } from '@mui/material';

import { Dimens } from '~themes';

const rectProps = {
	x: 4,
	y: 4,
	width: 16,
	height: 16,
	rx: Dimens.radiusXs,
	fill: 'var(--checkbox-bg, transparent)',
	stroke: 'var(--checkbox-border, currentColor)',
	strokeWidth: 1,
};

export const CheckboxIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox='0 0 24 24'>
		<rect {...rectProps} />
	</SvgIcon>
);

export const CheckboxCheckedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox='0 0 24 24'>
		<rect {...rectProps} />
		<path
			d='M8 12l3 3 5-6'
			fill='none'
			stroke='var(--checkbox-check, currentColor)'
			strokeWidth={2}
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</SvgIcon>
);

export const CheckboxIndeterminateIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox='0 0 24 24'>
		<rect {...rectProps} />
		<path
			d='M8 12h8'
			fill='none'
			stroke='var(--checkbox-check, currentColor)'
			strokeWidth={2}
			strokeLinecap='round'
		/>
	</SvgIcon>
);
